import type { RfqProject, RfqSubmission } from '../types';

type UpdateRfqProject = (id: string, patch: Partial<RfqProject>) => Promise<void>;

function rfqProjectsForDeal(rfqProjects: RfqProject[], dealId: string): RfqProject[] {
  return rfqProjects.filter(p => p.dealId === dealId);
}

function projectHasQuoteSubmissions(
  project: RfqProject,
  rfqSubmissions: RfqSubmission[],
): boolean {
  if (!project.id) return false;
  return rfqSubmissions.some(
    s =>
      s.rfqProjectId === project.id &&
      !s.notBidding &&
      (!!s.storagePath || !!s.cncQuote),
  );
}

/** Mark all rfqProjects for a deal closed when Project Hub completes the project. */
export async function closeRfqProjectsForDeal(
  dealId: string,
  rfqProjects: RfqProject[],
  updateRfqProject: UpdateRfqProject,
): Promise<void> {
  const matches = rfqProjectsForDeal(rfqProjects, dealId);
  await Promise.all(
    matches.map(p => {
      if (!p.id || p.status === 'closed') return Promise.resolve();
      return updateRfqProject(p.id, { status: 'closed' });
    }),
  );
}

/** Restore rfqProjects when Project Hub reopens a closed project. */
export async function reopenRfqProjectsForDeal(
  dealId: string,
  rfqProjects: RfqProject[],
  rfqSubmissions: RfqSubmission[],
  updateRfqProject: UpdateRfqProject,
): Promise<void> {
  const matches = rfqProjectsForDeal(rfqProjects, dealId);
  await Promise.all(
    matches.map(p => {
      if (!p.id || p.status !== 'closed') return Promise.resolve();
      const nextStatus = projectHasQuoteSubmissions(p, rfqSubmissions) ? 'quoted' : 'active';
      return updateRfqProject(p.id, { status: nextStatus });
    }),
  );
}
